const initState = {
    fetching: false,
    selectedIssue:{}
}

const SelectedIssueDataReducer = (state = initState, action) => {
    switch (action.type) {
        case 'FETCH_SELECTED_ISSUE_DATA':
            return {
                ...state,
                fetching_issue_data: true,
                error: ""
            }

        case 'FETCH_SELECTED_ISSUE_DATA_SUCCESSFUL':
            return {
                ...state,
                fetching_issue_data: false,
                selectedIssue: action.selectedIssue
            }
        
        default:
            return state;
    }

}

export default SelectedIssueDataReducer;